export const IMPERSONATION_STATUS_APPROVED = 'approved'
export const IMPERSONATION_STATUS_NONE = 'none'
export const IMPERSONATION_STATUS_REQUESTED = 'requested'
export const IMPERSONATION_STATUS_REVOKED = 'revoked'
export const IMPERSONATION_ACTION_APPROVE = 'approve'
export const IMPERSONATION_ACTION_REVOKE = 'revoke'
export const RESELLER_STATUS_ACTIVE = 'active'
export const RESELLER_STATUS_DISABLED = 'disabled'

export const getResellerImpersonationStatus = (item = {}) => {
  const status = String(item.impersonation_status || '').trim().toLowerCase()
  const allowed = String(item.impersonation_allowed ?? '').trim().toLowerCase()
  const isApproved = item.impersonation_allowed === true
    || item.impersonation_allowed === 1
    || ['1', 'true', 'yes', 'ja', IMPERSONATION_STATUS_APPROVED].includes(allowed)

  if (isApproved || status === IMPERSONATION_STATUS_APPROVED) {
    return IMPERSONATION_STATUS_APPROVED
  }
  if (status === IMPERSONATION_STATUS_REQUESTED) {
    return IMPERSONATION_STATUS_REQUESTED
  }
  if (status === IMPERSONATION_STATUS_REVOKED) {
    return IMPERSONATION_STATUS_REVOKED
  }
  return IMPERSONATION_STATUS_NONE
}

export const getSubResellerImpersonationActions = ({
  status,
  isDirectChild = false,
  impersonationActive = false,
  isSelf = false,
  targetStatus = ''
}) => {
  const normalizedStatus = String(status || '').toLowerCase()
  const canMutate = isDirectChild && !impersonationActive

  return {
    showStart: normalizedStatus === IMPERSONATION_STATUS_APPROVED && !impersonationActive && !isSelf,
    startDisabled: String(targetStatus || '').toLowerCase() !== RESELLER_STATUS_ACTIVE,
    showRequest: canMutate && (
      normalizedStatus === IMPERSONATION_STATUS_NONE
      || normalizedStatus === IMPERSONATION_STATUS_REVOKED
    ),
    showWithdraw: canMutate && (
      normalizedStatus === IMPERSONATION_STATUS_REQUESTED
      || normalizedStatus === IMPERSONATION_STATUS_APPROVED
    ),
    withdrawsApproval: normalizedStatus === IMPERSONATION_STATUS_APPROVED
  }
}

export const getImpersonationPermissionDecision = (status) => {
  const normalizedStatus = String(status || '').toLowerCase()
  if (normalizedStatus === IMPERSONATION_STATUS_REQUESTED) {
    return { action: IMPERSONATION_ACTION_APPROVE, nextStatus: IMPERSONATION_STATUS_APPROVED }
  }
  if (normalizedStatus === IMPERSONATION_STATUS_APPROVED) {
    return { action: IMPERSONATION_ACTION_REVOKE, nextStatus: IMPERSONATION_STATUS_REVOKED }
  }
  return null
}
